export type NumberSystem = 'international' | 'indian';

export function formatCurrency(
  amount: number,
  currency = 'Rs.',
  system: NumberSystem = 'indian',
): string {
  const formatted = formatNumber(amount, system);
  return `${currency} ${formatted}`;
}

export function formatNumber(
  amount: number,
  system: NumberSystem = 'indian',
  decimals = 2,
): string {
  const d = Math.max(0, Math.trunc(decimals));
  if (!isFinite(amount)) return (0).toFixed(d);
  const fixed = amount.toFixed(d);
  const [intPart, dec] = fixed.split('.');
  const sign = intPart.startsWith('-') ? '-' : '';
  const digits = intPart.replace('-', '');
  // Trailing fractional part — empty when decimals is 0 (no dot).
  const frac = dec ? `.${dec}` : '';

  if (system === 'international') {
    const withCommas = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${sign}${withCommas}${frac}`;
  }

  // Indian/Nepali: last 3 grouped, then every 2 (12,34,567.89)
  if (digits.length <= 3) return `${sign}${digits}${frac}`;
  const last3 = digits.slice(-3);
  const rest = digits.slice(0, -3);
  const withCommas = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
  return `${sign}${withCommas}${frac}`;
}
